module.exports = __webpack_public_path__ + "static/EWY_Rebecca-fb34f326dec0198fa1f0737623df3af1.mp4";